<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row align="center" justify="center">
        <v-col>
          <h3><v-icon large>mdi-cube-outline</v-icon> Produtos</h3>
        </v-col>
        <v-col cols="3">
          <TheSearchInput v-model="search" />
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn 
            depressed 
            color="primary" 
            class="text-center mr-1" 
            :disabled="!products.length"
            :dark="products.length" 
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>
      <v-row v-if="checkAcess(['admin'])">
        <v-col class="text-right">
          <v-btn
            depressed
            color="primary"
            small
            :loading="loading"
            class="text-center mr-1"
            :dark="selected.length > 0"
            :disabled="selected.length === 0"
            @click="editPriceMargin(null, true)"
          >
            <v-icon color="white" small class="mr-1">mdi-margin</v-icon>Alterar Preços em Massa
            <span v-if="selected.length > 0">({{ selected.length }})</span>
          </v-btn>
          <v-btn depressed color="primary" small dark :loading="loading" @click="importCsv = true" class="text-center mr-1">
            <v-icon color="white" small class="mr-1">mdi-update</v-icon>Importar Csv Avise-me
          </v-btn>
          <v-btn depressed color="primary" small dark :loading="loading" @click="updatePrice()" class="text-center mr-1">
            <v-icon color="white" small class="mr-1">mdi-cash</v-icon>Atualizar Preços - Vtex
          </v-btn>
          <v-btn depressed color="primary" small dark :loading="loading" @click="syncVtex()" class="text-center">
            <v-icon color="white" small class="mr-1">mdi-shopping-search</v-icon>Buscar Produtos - Vtex
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>

      <v-progress-linear v-if="loading" :value="(quantity.actual * 100) / quantity.totaç"></v-progress-linear>

      <v-data-table
        fixed-header
        :headers="headers"
        :items="products"
        :loading="loading"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 30, 60, 90, -1],
          'items-per-page-text': 'Itens por Página',
        }"
        item-key="skuId"
        show-select
        v-model="selected"
      >
        <template v-slot:[`item.productName`]="{ item }">
          <div class="py-2">
            <h3>{{ item.productName }}</h3>
            <div class="caption"><b>Sku:</b> {{ item.skuName }} - <b>Referência</b>: {{ item.referenceId }}</div>
            <div class="caption"><b>Ean:</b> {{ item.productEan }}</div>
            <div class="caption">
              <span v-if="item.categoryNameFather"
                ><b>{{ item.categoryNameFather }} <v-icon x-small>mdi-chevron-right</v-icon> </b></span
              >
              {{ item.categoryName }}
            </div>
          </div>
        </template>
        <template v-slot:[`item.skuName`]="{}"> </template>
        <template v-slot:[`item.referenceId`]="{}"> </template>
        <template v-slot:[`item.productEan`]="{}"> </template>
        <template v-slot:[`item.categoryNameFather`]="{}"> </template>
        <template v-slot:[`item.categoryName`]="{}"> </template>
        <template v-slot:[`item.productImageUrl`]="{ item }">
          <div class="pa-1">
            <img :src="item.productImageUrl" height="48px" />
          </div>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ item.amount }}
          <v-tooltip bottom v-if="item.amount && checkAcess(['admin'])">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-icon x-small @mouseenter="loadStock(item)">
                  mdi-magnify
                </v-icon>
              </span>
            </template>
            <span>
              <div v-if="loadingProduct">
                <v-progress-circular indeterminate color="amber"></v-progress-circular>
              </div>
              <div v-if="!loadingProduct">
                <ul v-if="item.stock">
                  <li v-for="(el, i) in item.stock" :key="i">
                    {{ el.sellerId }} -
                    {{ el.stockAmount }}
                  </li>
                </ul>
              </div>
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.productPrice`]="{ item }">{{ item.productPrice | formatFullMoney }}</template>

        <template v-slot:[`item.action`]="{ item }">
          <TheToolTip color="blue" label="Definir margem de preço" class="mr-1" v-if="checkAcess(['admin'])">
            <v-icon @click="editPriceMargin(item, null)">mdi-margin</v-icon>
          </TheToolTip>
          <TheToolTip color="blue" label="Simular Buy Box" class="mr-1" v-if="checkAcess(['admin'])">
            <v-icon @click="openBuyBoxDialog(item)">mdi-truck-fast-outline</v-icon>
          </TheToolTip>
          <TheToolTip color="blue" :label="`Ultíma Atualização: ${$options.filters.formatFullDate(item.productLastUpdate)}`" class="mr-1">
            <v-icon>mdi-clock-outline</v-icon>
          </TheToolTip>
        </template>
      </v-data-table>
    </v-card>

    <TheDialog v-model="importCsv" icon="mdi-update" title="Importar Avise-me">
      <template>
        <v-form enctype="multipart/form-data">
          <v-file-input
            label="Escolha o Arquivo CSV"
            placeholder="Selecione..."
            accept=".csv, .txt"
            id="file"
            color="primary"
            outlined
            dense
          ></v-file-input>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey darken-2" depressed dark @click="sendCsvFile()">
          <v-icon class="mr-1">mdi-content-save</v-icon>
        </v-btn>
      </template>
    </TheDialog>

    <TheDialog v-model="downloadProducts" icon="mdi-update" title="Aviso">
      <template>
        <h3>Os produtos estão sendo atualizados!</h3>
        <h4>Ao final do processo um email será enviado.</h4>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="green" depressed dark @click="downloadProducts = false"> <v-icon class="mr">mdi-check</v-icon> Ok </v-btn>
      </template>
    </TheDialog>

    <TheDialog v-model="priceMarginDialog" title="Definição de Variação de preço" width="800px" icon="mdi-margin">
      <template>
        <p v-if="!massUpdate">
          Variação de Preço para o produto: <b>{{ object.productName }}</b>
        </p>
        <p v-if="massUpdate">
          Variação de Preço para o produto em massa.
        </p>

        <v-divider class="my-3"></v-divider>
        <h3 class="mb-5">Definição de Margem</h3>
        <v-row>
          <v-col cols="6">
            <v-text-field v-model="range.min" @change="getMin()" type="number" outlined label="Valor Mínimo em %"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="range.max" @change="getMax()" type="number" outlined label="Valor Máximo em %"></v-text-field>
          </v-col>
        </v-row>
        <div>
          <h3 class="mb-5">Definição de Variação Preço</h3>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="priceAbsolute.min"
                @change="setMinDiscount()"
                type="number"
                outlined
                label="Valor Mínimo Absoluto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="priceAbsolute.max"
                @change="setMaxDiscount()"
                type="number"
                outlined
                label="Valor Máximo Absoluto"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <div v-if="!massUpdate">
          <v-divider class="my-3"></v-divider>
          <h3>Valores em Real</h3>
          <v-simple-table>
            <tbody>
              <tr>
                <td>Preço Produto</td>
                <td>{{ object.productPrice | formatFullMoney }}</td>
              </tr>
              <tr>
                <td>Preço Máximo</td>
                <td>{{ (priceAbsolute.max * 100) | formatFullMoney }}</td>
              </tr>
              <tr>
                <td>Preço Mínimo</td>
                <td>{{ (priceAbsolute.min * 100) | formatFullMoney }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn class="my-5" color="primary" @click="update(object)">
          <v-icon class="mr-1">mdi-content-save</v-icon>
          Salvar</v-btn
        >
      </template>
    </TheDialog>

    <TheDialog v-model="buyBoxDialog" title="Simulação de BuyBox" width="800px" @closeFunction="closeBuyBox">
      <template>
        <p>
          Simulação para o produto: <b>{{ object.productName }}</b>
        </p>
        <p><b>Informe o CEP:</b></p>
        <v-text-field
          single-line
          hide-details
          outlined
          dense
          color="primary"
          class="my-5"
          placeholder="00000-000"
          v-model="cep"
          v-mask="'#####-###'"
        ></v-text-field>

        <v-btn depressed color="primary" dark @click="getBuyBox()">
          <v-icon class="mr-1">mdi-magnify</v-icon>
          Simular
        </v-btn>

        <v-progress-linear v-if="loading" indeterminate rounded height="6"></v-progress-linear>

        <div v-if="buyBoxObjects.length > 0">
          <v-divider class="my-3"></v-divider>
          <v-simple-table>
            <thead>
              <tr>
                <th width="">Nome</th>
                <th width="">Preço</th>
                <th width="">Frete</th>
                <th width="">Preço final</th>
                <th width="">Entregue por:</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, i) in buyBoxObjects" :key="i">
                <td>{{ item.name }}</td>
                <td>{{ item.price | formatFullMoney }}</td>
                <td>{{ item.value | formatFullMoney }}</td>
                <td>{{ item.finalValue | formatFullMoney }}</td>
                <td>{{ item.carrierName }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <div class="my-5" v-if="notFound">
          <v-divider class="my-3"></v-divider>
          <h4><i> Nenhum seller foi encontrado </i></h4>
        </div>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mask } from 'vue-the-mask'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'

import TheDialog from '@/components/TheDialog'
import TheSearchInput from '@/components/TheSearchInput'
import TheToolTip from '@/components/TheToolTip'

export default {
  name: 'Product',
  directives: { mask },
  components: {
    TheSearchInput,
    TheToolTip,
    TheDialog,
  },
  computed: {
    ...mapState(['user', 'permissions', 'menu']),
    isAdmin() {
      for (let i = 0; i < this.permissions.length; i++) {
        const element = this.permissions[i]
        if (element.idRule === 'admin' || element.idRule === 'supplier-product') {
          return true
        }
      }
      return false
    },
  },
  data: () => ({
    loading: false,
    loadingProduct: false,
    products: [],
    object: {},
    search: null,
    importCsv: false,
    downloadProducts: false,
    priceMarginDialog: false,
    priceHistory: true,
    min: -100,
    max: 100,
    cep: '',
    range: {
      min: 0,
      max: 0,
    },
    buyBoxDialog: false,
    notFound: false,
    buyBoxObjects: [],
    headers: [
      { text: 'ID', value: 'skuId', width: '64px' },
      { text: '', value: 'productImageUrl', width: '90px' },
      { text: 'Nome', value: 'productName', width: '40%' },
      { text: '', value: 'categoryNameFather', width: '0%' },
      { text: '', value: 'categoryName', width: '0%' },
      { text: '', value: 'skuName', width: '0%' },
      { text: '', value: 'referenceId', width: '0%' },
      { text: '', value: 'productEan', width: '0%' },
      { text: 'Preço', value: 'productPrice' },
      { text: 'Estoque', value: 'amount' },
      { text: 'Avise-me', value: 'productQuantityRequest' },
      { text: 'Ações', value: 'action', width: '10%' },
    ],
    selected: [],
    massUpdate: false,
    quantity: {},
    priceAbsolute: {
      min: 0,
      max: 0,
    },
  }),
  methods: {
    loadProducts() {
      this.loading = true
      const url = `${baseApiUrl}/product`
      axios
        .get(url)
        .then((res) => {
          this.products = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    loadStock(item) {
      this.loadingProduct = true
      const url = `${baseApiUrl}/product/${item.skuId}/stock`
      axios
        .get(url)
        .then((res) => {
          this.loadingProduct = false
          item.stock = res.data
        })
        .catch(showError)
    },
    updatePrice() {
      const url = `${baseApiUrl}/vtex/updatePrice`
      this.loading = true
      axios
        .get(url)
        .then((data) => {
          this.loadProducts()
          this.loading = false
        })
        .catch(showError)
    },
    async update(item) {
      if (!this.massUpdate) {
        this.selected = [item]
      }
      this.quantity = {
        total: this.selected.length,
        actual: 0,
      }
      this.loading = true

      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i]
        const id = element.skuId
        const object = {}
        object.minPriceRange = this.range.min
        object.maxPriceRange = this.range.max
        object.priceMarginAbsoluteMin = this.priceAbsolute.min
        object.priceMarginAbsoluteMax = this.priceAbsolute.max
        const url = `${baseApiUrl}/product/${id}/price/range`
        this.priceMarginDialog = false
        await axios
          .patch(url, object)
          .then(() => {
            this.quantity.actual += 1
          })
          .catch(showError)
      }
      if (this.quantity.actual === this.quantity.total) {
        this.range = {
          min: 0,
          max: 0,
        }
        this.priceAbsolute = {
          min: 0,
          max: 0,
        }
        this.$toasted.global.defaultSuccess()
        this.massUpdate = false
        this.selected = []
        this.loadProducts()
      }
    },
    editPriceMargin(item, mass = false) {
      if (item) {
        this.object = item
        this.selected = []
        this.massUpdate = false
      } else if (mass) {
        this.object = {}
        this.massUpdate = mass
      }
      this.range = {
        min: 0,
        max: 0,
      }
      this.priceAbsolute = {
        min: 0,
        max: 0,
      }
      this.priceAbsolute = {
        min: 0,
        max: 0,
      }
      if (item && !isNaN(item.minPriceRange) && !isNaN(item.maxPriceRange)) {
        this.range.min = item.minPriceRange
        this.range.max = item.maxPriceRange
      }
      this.priceAbsolute = {
        min: item.priceMarginAbsoluteMin,
        max: item.priceMarginAbsoluteMax,
      }
      this.priceMarginDialog = true
    },
    sendCsvFile() {
      this.loading = true
      this.importCsv = false

      const url = `${baseApiUrl}/product`
      const file = document.querySelector('#file')
      var formData = new FormData()
      formData.append('fileCsv', file.files[0])
      axios
        .put(url, formData, {
          headers: {
            'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
          },
        })
        .then((res) => {
          this.loadProducts()
        })
        .catch((err) => {
          this.snackColor = 'error'
          this.snackText = err.message
        })
    },
    syncVtex() {
      this.loading = true
      const url = `${baseApiUrl}/syncProduct`
      axios
        .get(url)
        .then(() => {
          this.loading = false
          this.downloadProducts = true
          this.loadProducts()
        })
        .catch(showError)
    },
    openBuyBoxDialog(item) {
      this.notFound = false
      this.object = item
      this.buyBoxDialog = true
    },
    getBuyBox() {
      this.notFound = false
      this.loading = true
      const url = `${baseApiUrl}/store/simulate`
      const object = { sku: this.object.skuId, cep: this.cep, quantity: 1 }
      axios
        .post(url, object)
        .then((res) => {
          this.buyBoxObjects = res.data
          if (res.data.length === 0) {
            this.notFound = true
          }
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    closeBuyBox() {
      this.buyBoxObjects = []
      this.object = {}
      this.cep = ''
    },
    getMax() {
      this.priceAbsolute.max = (this.object.productPrice + (this.range.max * this.object.productPrice) / 100) / 100
    },
    getMin() {
      this.priceAbsolute.min = (this.object.productPrice + (this.range.min * -1 * this.object.productPrice) / 100) / 100
    },
    setMaxDiscount() {
      this.range.max = null
    },
    setMinDiscount() {
      this.range.min = null
    },

    checkAcess(groups) {
      return groups.find((group) => {
        return this.user.groups.includes(group)
      })
    },
    downloadCSV() {
      const data = this.products
      const fileName = 'Produtos'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  mounted() {
    this.loadProducts()
  },
}
</script>
<style scoped>
.hide {
  display: none !important;
}
</style>
